import React from "react";
import { ActivityModule, Modules } from "../../../constants/Module";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import CreatorDetails from "./creatorDetails";
import { withTranslation } from "react-i18next";

const EditMilestone = ({ item,t }) => {
    return (
        <React.Fragment>
            <div className="mx-2">
                {item?.module === ActivityModule.CHANGE_REQUEST_ITEM &&
                    <div>
                        <strong> {t('Edit')} {ucFirst(Modules.MILESTONE)} ({typeof item?.payload?.displayPayload?.name === 'object' ? item?.payload?.displayPayload?.name?.old : item?.payload?.displayPayload?.name}) </strong>
                        {item?.event === Action.CREATE ? t('was added to') : t('was removed from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
                {item?.module === ActivityModule.MILESTONE &&
                    <div>
                        <strong> {ucFirst(Modules.MILESTONE)} ({typeof item?.payload?.name === 'object' ? item?.payload?.name?.old : item?.payload?.name}) </strong>
                        {t('was updated from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong> {t('to')} <strong>{t('startup')} ({item?.project?.uniqueProjectId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
                {item?.event === Action.CREATE &&
                    <div>
                        {item?.payload?.payload?.name &&
                            item?.payload?.payload?.name?.old &&
                            item?.payload?.payload?.name?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Name') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.name?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.name?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {typeof item?.payload?.payload?.weight === 'object' && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Weight') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.weight?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.weight?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.payload?.output &&
                            item?.payload?.payload?.output?.old &&
                            item?.payload?.payload?.output?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Output') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.output?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.output?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.payload?.description &&
                            item?.payload?.payload?.description?.old &&
                            item?.payload?.payload?.description?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Description') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.description?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.description?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.payload?.estimatedStartDate &&
                            item?.payload?.payload?.estimatedStartDate?.old &&
                            item?.payload?.payload?.estimatedStartDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Start Date') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.estimatedStartDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.estimatedStartDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.payload?.estimatedEndDate &&
                            item?.payload?.payload?.estimatedEndDate?.old &&
                            item?.payload?.payload?.estimatedEndDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('End Date') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.estimatedEndDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.estimatedEndDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                        {item?.payload?.payload?.items &&
                            item?.payload?.payload?.items.length > 0 && (
                                <div className="mx-2 mt-1">
                                    <strong> {t('Budget Items') + ':'}</strong>
                                    {item?.payload?.payload?.items.map((item, index) => (
                                        <div key={index} className="d-flex align-items-center change_status mx-4 mt-1">
                                            <strong> {item?.budgetType} </strong>
                                            &nbsp;was {item?.id ? t('removed') : t('added')} {t('with planned cost')}  &nbsp;<strong>{item?.plannedCost}</strong>
                                        </div>
                                    ))}
                                </div>
                            )}
                    </div>
                }
                 {item?.event === Action.UPDATE &&
                    <div>
                        {item?.payload?.name &&
                            item?.payload?.name?.old &&
                            item?.payload?.name?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Name') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.name?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.name?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {item?.payload?.cost &&
                            item?.payload?.cost?.old &&
                            item?.payload?.cost?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Cost') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{parseFloat(item?.payload?.cost?.old).toFixed(2)}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {parseFloat(item?.payload?.cost?.new).toFixed(2)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {typeof item?.payload?.weight === "object" && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Weight') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.weight?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.weight?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.output &&
                            item?.payload?.output?.old &&
                            item?.payload?.output?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Output') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.output?.old ?? 'N/A'}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.output?.new ?? 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.description &&
                            item?.payload?.description?.old &&
                            item?.payload?.description?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Description') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.description?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.description?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.estimatedStartDate &&
                            item?.payload?.estimatedStartDate?.old &&
                            item?.payload?.estimatedStartDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Start Date') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.estimatedStartDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.estimatedStartDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.estimatedEndDate &&
                            item?.payload?.estimatedEndDate?.old &&
                            item?.payload?.estimatedEndDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('End Date') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.estimatedEndDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.estimatedEndDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                        {item?.payload?.items &&
                            item?.payload?.items.length > 0 && (
                                <div className="mx-2 mt-1">
                                    <strong> {t('Budget Items') + ':'}</strong>
                                    {item?.payload?.items.map((item, index) => (
                                        <div key={index} className="d-flex align-items-center change_status mx-4 mt-1">
                                            <strong> {item?.budgetType} </strong>
                                            &nbsp;{item?.id ? t('was removed with planned cost') : t('was added with planned cost')} &nbsp;<strong>{item?.plannedCost}</strong>
                                        </div>
                                    ))}
                                </div>
                            )}
                    </div>
                }
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(EditMilestone);
